module.exports = __webpack_public_path__ + "img/a4f9859.png";